import { Controller } from "@hotwired/stimulus";

function debounce(func, wait) {
    let timeout;
    return function (...args) {
        const context = this;
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(context, args), wait);
    };
}

export default class extends Controller {
    static get targets() {
        return ["newImageFile", "form", "imageContainer", "image", "imageUrl", "staticImageUrl", "imageFile", "gifDisplayContainer", "removeGifContainer", "gifSearch", "gifResults", "gifContainer", "addAnImageButton", "addAGifButton"];
    }

    connect() {
        this.searchGifs = debounce(this.searchGifs.bind(this), 300);
    }

    addAGif(e) {
        const API_KEY = 'g3pi3jckPqURR1zVYe74UfEJvI5sUfMH';
        fetch(`https://api.giphy.com/v1/gifs/trending?api_key=${API_KEY}&limit=50&rating=pg-13`)
            .then(response => response.json())
            .then(data => {
                const gifResults = this.gifResultsTarget;
                gifResults.innerHTML = '';
                data.data.forEach(gif => {
                    const img = document.createElement('img');
                    img.src = gif.images.fixed_height.url;
                    img.alt = gif.title;
                    img.setAttribute('data-still', gif.images.fixed_height_still.url);
                    img.setAttribute('data-gif', gif.images.fixed_height.url);
                    img.setAttribute('loading', 'lazy');
                    img.onclick = () => this.selectGif(gif.images.fixed_height.url, gif.images.fixed_height_still.url);
                    gifResults.appendChild(img);
                });
            })
            .catch(error => console.error('Error fetching GIFs:', error));
    }

    searchGifs() {
        const API_KEY = 'g3pi3jckPqURR1zVYe74UfEJvI5sUfMH';
        let query = this.gifSearchTarget.value;

        if (query === '') {
            fetch(`https://api.giphy.com/v1/gifs/trending?api_key=${API_KEY}&limit=50&rating=pg-13`)
                .then(response => response.json())
                .then(data => {
                    const gifResults = this.gifResultsTarget;
                    gifResults.innerHTML = '';
                    data.data.forEach(gif => {
                        const img = document.createElement('img');
                        img.src = gif.images.fixed_height.url;
                        img.alt = gif.title;
                        img.setAttribute('data-still', gif.images.fixed_height_still.url);
                        img.setAttribute('data-gif', gif.images.fixed_height.url);
                        img.setAttribute('loading', 'lazy');
                        img.onclick = () => this.selectGif(gif.images.fixed_height.url, gif.images.fixed_height_still.url);
                        gifResults.appendChild(img);
                    });
                })
                .catch(error => console.error('Error fetching GIFs:', error));
        } else {
            fetch(`https://api.giphy.com/v1/gifs/search?api_key=${API_KEY}&q=${query}&limit=50&rating=pg-13`)
                .then(response => response.json())
                .then(data => {
                    const gifResults = this.gifResultsTarget;
                    gifResults.innerHTML = '';
                    data.data.forEach(gif => {
                        const img = document.createElement('img');
                        img.src = gif.images.fixed_height.url;
                        img.alt = gif.title;
                        img.setAttribute('data-still', gif.images.fixed_height_still.url);
                        img.setAttribute('data-gif', gif.images.fixed_height.url);
                        img.setAttribute('loading', 'lazy');
                        img.onclick = () => this.selectGif(gif.images.fixed_height.url, gif.images.fixed_height_still.url);
                        gifResults.appendChild(img);
                    });
                })
                .catch(error => console.error('Error fetching GIFs:', error));
        }
    }

    searchGifsEnter(e) {
        e.preventDefault();
    }

    selectGif(url, staticUrl) {
        this.clearImage();
        this.imageUrlTarget.value = url;
        this.staticImageUrlTarget.value = staticUrl;

        const detailsEditorDiv = this.element.querySelector('.c-feed-post__details-gif');
        const existingGif = detailsEditorDiv.querySelector('.gif');

        if (existingGif) {
            existingGif.src = url;
        } else {
            detailsEditorDiv.insertAdjacentHTML('beforeend', `<img src="${url}" data-still="${staticUrl}" alt="Selected GIF" class="gif">`);
        }

        this.gifDisplayContainerTarget.classList.remove("d-none");
        this.removeGifContainerTarget.classList.remove("d-none");
        bootstrap.Dropdown.getOrCreateInstance(this.addAGifButtonTarget).hide();
    }

    removeGif(e) {
        e.preventDefault();
        this.clearGif();
    }

    clearGif(e) {
        if (!this.hasImageUrlTarget) {
            return;
        }

        this.imageUrlTarget.value = '';

        const detailsEditorDiv = this.element.querySelector('.c-feed-post__details-gif');
        const existingGif = detailsEditorDiv.querySelector('.gif');

        if (existingGif) {
            existingGif.remove();
        }

        this.gifDisplayContainerTarget.classList.add("d-none");
        this.removeGifContainerTarget.classList.add("d-none");
    }

    imageFileChanged() {
        if (this.newImageFileTarget.files.length > 0) {
            this.clearGif();
        }

        this.renderImage();
        bootstrap.Tooltip.getInstance(this.addAnImageButtonTarget)?.hide();
    }

    formTargetConnected(target) {
        if (!this.hasNewImageFileTarget) {
            return;
        }

        if (!this.newImageFileTarget.form) {
            this.newImageFileTarget.value = null;
            this.newImageFileTarget.setAttribute("form", target.id);
            return;
        }

        this.renderImage();
    }

    addAnImage(e) {
        e.preventDefault();
        this.newImageFileTarget.click();
    }

    removeImage(e) {
        e.preventDefault();
        this.clearImage();
    }

    renderImage() {
        if (this.newImageFileTarget.files.length > 0) {
            const file = this.newImageFileTarget.files[0];
            const fileReader = new FileReader();
            fileReader.addEventListener("load", _ => {
                this.imageTarget.src = fileReader.result;
                this.imageContainerTarget.classList.remove("d-none");
            });
            fileReader.readAsDataURL(file);
        } else if (!this.hasImageFileTarget || this.imageFileTarget.value === "") {
            this.imageContainerTarget.classList.add("d-none");
            this.imageTarget.src = "";
        }
    }

    clearImage(e) {
        if (!this.hasNewImageFileTarget) {
            return;
        }

        this.newImageFileTarget.value = null;

        if (this.hasImageFileTarget) {
            this.imageFileTarget.value = null;
        }

        this.renderImage();
    }
}